import { AnalysisSaleChartData } from 'utils/types/AnalysisSale';

export const analysisChartData: AnalysisSaleChartData = {
    isLoading: false,
    pageType: 'analysis',
    chartData: [],
    afterSearch: false
};

